import { render } from "./_Cadastro.vue?vue&type=template&id=10117f89"
import script from "./_Cadastro.vue?vue&type=script&lang=ts"
export * from "./_Cadastro.vue?vue&type=script&lang=ts"
script.render = render

export default script